export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M8 3v19c0 3.9 3.1 7 7 7h11" stroke="#D4AF37" strokeWidth="2.1" strokeLinecap="round" />
    <path d="M13.5 3v15c0 2.8 2.2 5 5 5h7.5" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
    <path d="M19 3v11c0 1.9 1.6 3.5 3.5 3.5H26" stroke="#800020" strokeWidth="2.1" strokeLinecap="round" />
    <circle cx="8" cy="3" r="1.6" fill="#D4AF37" />
  </svg>
);

export const Logo = ({ tone = "navy" }) => {
  const color = tone === "cream" ? "text-cream" : "text-navy";
  return (
    <span className={`inline-flex items-center gap-3 ${color}`} data-testid="locka-logo">
      <LogoMark />
      <span className="font-serif text-[1.65rem] leading-none tracking-[0.14em]">Locka</span>
    </span>
  );
};
